import { useEffect } from 'react';
import { debounce } from 'lodash-es';

export default () => {
  const collapseRefinements = () => {
    const unifiedSearchFiltersEl = document.querySelectorAll('.unifiedSearchFilters');

    unifiedSearchFiltersEl.forEach((el) => {
      const accordions = Array.from(el?.getElementsByTagName('details'));
      accordions.forEach((detail) => {
        detail.removeAttribute('open');
      });
    });
  };

  useEffect(() => {
    const checkScreenSize = debounce(() => {
      if (window.innerWidth < 768) {
        collapseRefinements();
      }
    }, 100);
    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  return collapseRefinements;
};
